// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Map_wrapper__fMDHB"};